import { render, staticRenderFns } from "./DealsItems.vue?vue&type=template&id=85311e3a"
import script from "./DealsItems.vue?vue&type=script&lang=js"
export * from "./DealsItems.vue?vue&type=script&lang=js"
import style0 from "./DealsItems.vue?vue&type=style&index=0&id=85311e3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports